import { hasValue } from 'swipeclock-frontend';
import { localStorageKeys } from 'constants/storageConstants';

export function getWebClockUserStorageKey(user) {
  const site = user?.site;
  const employeeId = user?.employeeId;

  if (hasValue(site) && hasValue(employeeId)) {
    return `${site}:${employeeId}`;
  }

  return null;
}

export function getOfflinePunchQueueStorageKey(userKey) {
  if (!hasValue(userKey)) {
    return null;
  }

  return `${localStorageKeys.WEBCLOCK_OFFLINE_PUNCH_QUEUE_PREFIX}:${userKey}`;
}

export function getClockConnectCacheStorageKey(userKey) {
  if (!hasValue(userKey)) {
    return null;
  }

  return `${localStorageKeys.WEBCLOCK_CLOCK_CONNECT_CACHE_PREFIX}:${userKey}`;
}
